import { Component, AfterViewInit, AfterViewChecked, OnDestroy, ChangeDetectorRef, } from '@angular/core';
import { Router, ActivatedRoute, } from '@angular/router';
import { TdLoadingService, TdDialogService, StepState, } from '@covalent/core';
import { MdSelect } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs';

import { CitasService, MasterService, LoginService, } from '../../../../services/';

import { Cita } from '../../../../models';

@Component({
  selector: 'qs-citasalta',
  styleUrls: ['./citasalta.component.scss'],
  templateUrl: './citasalta.component.html',
  viewProviders: [CitasService],
})

export class CitasAltaComponent implements AfterViewInit, AfterViewChecked, OnDestroy {

  private mode: string;
  private cita: Cita;
  private oldCita: Cita;
  private fechasDisponibles: any[];
  private horasDisponibles: any[];

  public activeDeactiveStep1Msg: string = 'No seleccionado/deseleccionado todavía';
  public stateStep1: StepState = StepState.Required;
  public stateStep2: StepState = StepState.Required;
  public stateStep3: StepState = StepState.Complete;
  public disabled: boolean = false;
  public title: string;
  public fechaSeleccionada: string = '';
  public horaSeleccionada: string = '';

  constructor(private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _citasService: CitasService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef) {
    this.cita = new Cita();
    this.oldCita = new Cita();
    if (this._loginService.transient) {
      this.mode = 'edit';
      this.title = 'Editar';
      let cita: Cita = this._loginService.transient;
      this.cita.fecha = cita.fecha;
      this.cita.agenda = cita.agenda;
      this.cita.borrable = cita.borrable;
      this.cita.centro = cita.centro;
      this.cita.demandante = cita.demandante;
      this.cita.descripcion = cita.descripcion;
      this.cita.duracion = cita.duracion;
      this.cita.hora = cita.hora;
      this.oldCita.agenda = cita.agenda;
      this.oldCita.fecha = cita.fecha;
      this.oldCita.borrable = cita.borrable;
      this.oldCita.centro = cita.centro;
      this.oldCita.demandante = cita.demandante;
      this.oldCita.descripcion = cita.descripcion;
      this.oldCita.duracion = cita.duracion;
      this.oldCita.hora = cita.hora;
    } else {
      this.mode = 'add';
      this.title = 'Añadir';
      this.cita.fecha = new Date().toDateString();
      this.oldCita.fecha = new Date().toDateString();
    }
  }

  /**
   * FIX: Esto es un fix para ExpressionChangedAfterItHasBeenCheckedError
   * Aparece al cargar un componente de la vista con datos desde un servicio
   */
  ngAfterViewChecked(): void {
    this._changeDetectorRef.detectChanges();
  }

  ngAfterViewInit(): void {
    this._loadingService.register('cita.load');
    this.cita = new Cita();
    let fecha: Date = new Date();
    this.cita.fecha = fecha.getDate() + '/' + fecha.getMonth() + '/' + fecha.getFullYear();
    this._citasService.obtenerFechasHueco(
      this._loginService.consulta.cip,
      this._loginService.agenda,
      this.cita.fecha).subscribe((res: any) => {
        if (res.error !== undefined) {
          this._loadingService.resolve('cita.load');
          this._loginService.mostrarMensaje('Error: ' + res.error.descripcion, 'OK', 6000);
        } else {
          this._loadingService.resolve('cita.load');
          this.fechasDisponibles = res.respuesta.fechas || '';
        }
      }, (error: Error) => {
        setTimeout(() => {
          this._loginService.mostrarMensaje('Error obteniendo las fechas disponibles: ' + error, 'OK', 6000);
        }, 400);
      });
    this._changeDetectorRef.detectChanges();
  }

  changeStep1(): void {
    if (this.fechaSeleccionada !== '') {
      this._citasService.obtenerHuecos(
        this._loginService.consulta.cip,
        this._loginService.agenda,
        this.fechaSeleccionada).subscribe((res: any) => {
          if (res.error !== undefined) {
            this._loginService.mostrarMensaje('Error: ' + res.error.descripcion, 'OK', 6000);
          } else {
            this.horasDisponibles = res.respuesta.horas;
          }
        }, (error: Error) => {
          this._loginService.mostrarMensaje('Error obteniendo horas disponibles.', 'OK', 6000);
        });
    }
  }

  save(): void {
    this.mode = 'save';
    this._loadingService.register();
    let errorMessage: string = 'Error estableciendo la cita.';
    let message: string = 'Cita establecida correctamente.';
    let action: string = 'Ok';
    let duration: number = 6000;
    let route: string = '/main/consulta/' + this._loginService.consulta.numeroExpediente + '/citas/';
    this._citasService.confirmarCita(
      this._loginService.consulta.cip,
      this._loginService.agenda,
      this.fechaSeleccionada,
      this.horaSeleccionada).subscribe((res: any) => {
        if (res.respuesta !== undefined) {
          this._loginService.mostrarMensaje(message, action, duration);
          this._loadingService.resolve();
          this._router.navigate([route]);
        } else {
          this._loadingService.resolve();
          this._loginService.mostrarMensaje(res.error.descripcion, action, duration);
        }
      }, (error: Error) => {
        this._loginService.mostrarMensaje(errorMessage, action, duration);
        this._loadingService.resolve();
      });
  }

  canDeactivate(): Promise<boolean> | boolean {
    if (this.mode === 'save') {
      return true;
    }
    if ((this.oldCita.agenda === this.cita.agenda) &&
      (this.oldCita.fecha === this.cita.fecha) &&
      (this.oldCita.hora === this.cita.hora)) {
      return true;
    } else {
      return new Promise((resolve: any) => {
        this._dialogService.openConfirm({
          message: 'Si pulsa aceptar, se perderán los datos introducidos.',
          title: '¿Desea abandonar el alta de cita?',
          acceptButton: 'Aceptar',
          cancelButton: 'Cancelar',
        }).afterClosed().subscribe((accept: boolean) => {
          if (accept) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    }
  }

  ngOnDestroy(): void {
    this._loginService.transient = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/citas/citasalta/citasalta.component.ts